import {inject, Injectable} from '@angular/core';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({
  providedIn: 'root'
})
export class JsonExtractorService {
  //Injectbales
  private _console = inject(Tools_aiConsoleService);

  constructor() { }

  extractJSON(text: string): any[] {
    const jsonObjects: any[] = [];
    let stack: string[] = [];
    let startIndex = -1;
    let inString = false; // Para ignorar llaves dentro de strings

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      // Manejar caracteres escapados dentro de strings
      if (char === '"' && text[i - 1] !== '\\') {
        inString = !inString;
      }

      if (!inString) {
        if (char === '{') {
          if (stack.length === 0) {
            startIndex = i; // Inicio del JSON
          }
          stack.push(char);
        } else if (char === '}') {
          if (stack.length > 0) {
            stack.pop();
            if (stack.length === 0 && startIndex !== -1) { // JSON completo
              const jsonSubstring = text.slice(startIndex, i + 1);
              try {
                const jsonObj = JSON.parse(jsonSubstring);
                jsonObjects.push(jsonObj);
              } catch (error) {
                // Ignorar JSON inválido
              }
              startIndex = -1;
            }
          }
        }
      }
    }

    return jsonObjects;
  }
}
